import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import Terra from '../Terra';
import {
  EnvironmentResponse,
  EnvironmentsResponse,
} from 'data/terra/api/terra/response/EnvironmentsResponse';
import { EnvironmentDescription } from 'data/terra/Environment';

class EnvironmentEndpoint {
  getEnvironmentsUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/envs`;
}


export class EnvironmentApi {
  terraClient: AxiosInstance;
  endpoint = new EnvironmentEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchEnvironments(): Promise<Result<EnvironmentsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<EnvironmentsResponse>(
            this.endpoint.getEnvironmentsUrl(),
            {
              params: {
                pageSize: 50,
              },
            }
          )
        ).data
    );
  }

  addEnvironment(
    data: EnvironmentDescription
  ): Promise<Result<EnvironmentResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<EnvironmentResponse>(
            this.endpoint.getEnvironmentsUrl(),
            data
          )
        ).data
    );
  }
}